export default __webpack_public_path__ + "static/media/Path3412.41fc6f9e.svg";